import { convertCase } from '@/utils';
import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_profit.';
export const workerProfitSearchDateType = {
    // 일별
    DAILY: 'DAILY',
    // 월별
    MONTHLY: 'MONTHLY',
};
const workerProfitSearchDateTypeList = [
    workerProfitSearchDateType.DAILY,
    workerProfitSearchDateType.MONTHLY,
];
const workerProfitSearchDateTypeOptionList = workerProfitSearchDateTypeList
    .map((value) => {
    const text = convertCase(value, 'enum', 'snake');
    return {
        text: t(lc + text),
        value,
    };
});
export { workerProfitSearchDateTypeOptionList };
